// extracted by mini-css-extract-plugin
module.exports = {"rnv45ui":"rnv45ui"};